const HIMT_LOGO_URL = "/himt-logo.png";

export const Logo = ({ className = "", variant = "default" }) => {
  if (variant === "mark") {
    return (
      <img
        src={HIMT_LOGO_URL}
        alt="HIMT"
        className={`h-10 w-10 object-contain ${className}`}
        data-testid="himt-logo-mark"
      />
    );
  }
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="himt-logo">
      <img src={HIMT_LOGO_URL} alt="HIMT" className="h-11 w-11 object-contain" />
      <div className="font-display font-black text-[#0A2540] leading-none">
        <div className="text-xl tracking-tighter">HIMT</div>
        <div className="text-[9px] tracking-[0.2em] uppercase text-slate-500 mt-0.5">
          Video Assessment for Additional Screening
        </div>
      </div>
    </div>
  );
};

export const RecordingDot = () => (
  <div className="flex items-center gap-2" data-testid="recording-indicator">
    <span className="h-2.5 w-2.5 rounded-full bg-[#EF4444] recording-pulse" />
    <span className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#EF4444] font-mono">REC</span>
  </div>
);

export const VoiceWave = ({ active = false, level = 0 }) => (
  <div className="flex items-end gap-1 h-12" aria-hidden="true" data-testid="voice-wave">
    {[0, 1, 2, 3, 4, 5, 6].map((i) => {
      const h = active ? Math.max(14, Math.min(48, 14 + level * 300 + Math.random() * 14)) : 6;
      return (
        <span
          key={i}
          className={`voice-bar w-1.5 ${active ? "bg-[#0A2540]" : "bg-slate-300"} rounded-sm`}
          style={{ height: `${h}px` }}
        />
      );
    })}
  </div>
);

export const Overline = ({ children, className = "" }) => (
  <div className={`text-[11px] tracking-[0.25em] uppercase font-bold text-slate-500 ${className}`}>
    {children}
  </div>
);

export const StatCard = ({ label, value, sub, accent }) => (
  <div className="bg-white border border-slate-200 rounded-sm p-5 hover:border-[#0A2540] transition-colors">
    <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-slate-500">{label}</div>
    <div className={`font-mono font-black text-3xl mt-2 ${accent || "text-[#0A2540]"}`}>{value}</div>
    {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
  </div>
);
